import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["collapsing", "collapser", "expander"];
  static outlets = ["collapsing"];

  expand(event) {
    if (event) {
      event.preventDefault();
    }
    if (this.hasCollapsingOutlet) {
      this.collapsingOutlet.expand();
    }

    if (this.hasCollapsingTarget) {
      this.collapsingTarget.classList.remove("hidden");
      this.collapsingTarget.setAttribute("aria-expanded", true);
    }

    if (this.hasExpanderTarget && this.hasCollapserTarget) {
      this.collapserTarget.classList.remove("hidden");
      this.expanderTarget.classList.add("hidden");
    }
    if (this.hasCollapserTarget) {
      this.collapserTarget.setAttribute("aria-expanded", true);
    }
    if (this.hasExpanderTarget) {
      this.expanderTarget.setAttribute("aria-expanded", true);
    }
  }

  collapse(event) {
    if (event) {
      event.preventDefault();
    }
    if (this.hasCollapsingOutlet) {
      this.collapsingOutlet.collapse();
    }
    if (this.hasCollapsingTarget) {
      this.collapsingTarget.classList.add("hidden");
      this.collapsingTarget.setAttribute("aria-expanded", false);
    }

    if (this.hasExpanderTarget && this.hasCollapserTarget) {
      this.collapserTarget.classList.add("hidden");
      this.expanderTarget.classList.remove("hidden");
    }
    if (this.hasCollapserTarget) {
      this.collapserTarget.setAttribute("aria-expanded", false);
    }
    if (this.hasExpanderTarget) {
      this.expanderTarget.setAttribute("aria-expanded", false);
    }
  }

  toggle(event) {
    if (this.isExpanded()) {
      this.collapse(event);
    } else {
      this.expand(event);
    }
  }

  isExpanded() {
    if (this.hasExpanderTarget) {
      console.debug("expander says", this.expanderTarget.getAttribute("aria-expanded"));
      return this.expanderTarget.getAttribute("aria-expanded") == "true";
    }
    if (this.hasCollapserTarget) {
      console.debug("collapser says", this.collapserTarget.getAttribute("aria-expanded"));
      return this.collapserTarget.getAttribute("aria-expanded") == "true";
    }
  }
}
